<div class="visible-lg">
  <div class="flex-container ">
    <div class="bmw-bulletin-container flex-60">
      <div class="bmw-bulletin-title">
        {{userInput ? (userInput?.action.charAt(0).toUpperCase() + userInput?.action.slice(1) + " " + userInput?.contentType?.name)
        : ''}}
      </div>
      <div class="bmw-bulletin-info">
        <div class="flex-container">
          <div class="bmw-bulletin-number-label flex-75">
            Number
          </div>
          <div class="bmw-bulletin-date flex-150-px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
            <div class="date">{{userInput?.date}}</div>
          </div>
        </div>

        <div class="flex-container" *ngIf='userInput?.action === "edit" && makeNameForApi ==="MOTORRAD"'>          
          <div class="cms-modal-select-make-checkbox">         
            <label class="container">Current
              <input type="radio" name="mcbulletininfo" value="mccurrent" [(ngModel)]="mcbinfo.options" (change)="handleMcbInfoChange($event)">
              <span class="checkmark"></span>
            </label>
            <label class="container">Legacy
              <input type="radio" name="mcbulletininfo" value="mclegacy" [(ngModel)]="mcbinfo.options" (change)="handleMcbInfoChange($event)">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <div class="flex-container">
          <div class="bmw-bulletin-number flex-150-px" *ngIf="showDefaultBn">
            <input type="text" [(ngModel)]='inputBulletinNumber' (keyup)="formatBulletinNumber($event)" placeholder="00 00 00" name="bulletin">
          </div>
          
          <div class="bmw-bulletin-number flex-300-px" *ngIf="!showDefaultBn">
            <input type="text" [(ngModel)]='inputBulletinNumber' placeholder="Enter Motorrad legacy bulletin number" name="bulletin">
          </div>

          <div class="flex-15" *ngIf='userInput?.action === "edit"'>
            <select class="form-control" id="group" [(ngModel)]='makeNameForApi' (change)="handleGroupChange($event)" style="width: 100%; margin-left:3px">              
              <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="BMW">BMW</option>
              <option *ngIf="!isMotorradAdmin && !isRollsRoyceAdmin" value="MINI">MINI</option>      
              <option *ngIf="isAdmin || isMotorradAdmin" value="MOTORRAD">MOTORRAD</option>
              <option *ngIf="isAdmin || isRollsRoyceAdmin" value="ROLLSROYCE">ROLLSROYCE</option>
            </select>
          </div>
          <div *ngIf='userInput?.action === "edit"' class="bmw-bulletin-date flex">
            <button [disabled]='!inputBulletinNumber' class="bmw-button-secondary" (click)='getBulletinDetails(inputBulletinNumber)'>Find Bulletin</button>
          </div>
        </div>
        <small *ngIf='userInput?.action === "edit"' style="font-weight: bold" [ngStyle]='{"color": bulletinActiveStatus ? "#59a946" : "#8b928a"}'>
          {{bulletinActiveStatus ? "Active" : "In-active"}}
        </small>
        <div class="bmw-bulletin-subject-label">Subject</div>
        <div class="bmw-bulletin-subject">
          <input type="text" maxlength="80" [(ngModel)]='inputSubject' placeholder="Enter Subject" name="subject" [disabled]='userInput?.action === "edit" && showAllBulletinOptions == false'>
          <div class="bmw-bulletin-subject-length">{{ inputSubject ? inputSubject.length : '0' }}/80</div>
        </div>
        <div class="flex-container">
          <div *ngIf='userInput?.action === "edit"' class="flex-50">
              <label>Date</label>
              <div>
                <input type="date" name="mydate" [(ngModel)]="releaseDate"  class="form-control" required />
              </div>
          </div>
        </div>
        <div class="flex-container wrap" *ngIf="showTakata">
          <div class="flex-50" style="margin-top:25px">
            <label class="container is-takata-recall">Is Takata Recall?
              <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="flex-50">
            <label>Takata Recall Code</label>
            <div>
              <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428" [(ngModel)]="tkrCode" required>
            </div>
          </div>
        </div>

        <!-- Reactivate or Deactivate document  -->
        <!-- <div *ngIf='userInput?.action === "edit"' class="cms-modal-select-make-checkbox">
          <label class="container">Reactivate
            <input type="radio" id="reactivatePbs" name="reactivatePbs" value="reactivate" [(ngModel)]='reactivateOrDeactivate'>
            <span class="checkmark"></span>
          </label>
          <label class="container">Deactivate
            <input type="radio" id="deactivatePbs" name="deactivatePbs" value="deactivate" [(ngModel)]='reactivateOrDeactivate'>
            <span class="checkmark"></span>
          </label>
        </div> -->
        <small style="color: red">{{ errorMessage }}</small>
        <br/>
        <div class="flex-container">
          <div class="flex"></div>
          <button [disabled]='checkBulletinLength() || !inputSubject || disableServiceBulletin' (click)='createNewBulletin()' class="bmw-bulletin-save-button flex-90-px" *ngIf="userInput?.action === 'add' || showAllBulletinOptions == true">
            <i class="material-icons">save</i>Save
          </button>
        </div>
      </div>
      <div *ngIf="userInput?.action === 'edit' && showAllBulletinOptions == true" class="bmw-bulletin-info">
        <div class="cms-modal-select-make-checkbox">
          <label class="container">Reactivate
            <input type="radio" id="reactivatePbs" name="reactivatePbs" value="reactivate" [(ngModel)]='reactivateOrDeactivate'>
            <span class="checkmark"></span>
          </label>
          <label class="container">Deactivate
            <input type="radio" id="deactivatePbs" name="deactivatePbs" value="deactivate" [(ngModel)]='reactivateOrDeactivate'>
            <span class="checkmark"></span>
          </label>
        </div>
        <!-- <small style="color: red">{{errorMessage}}</small> -->
        <div class="flex-container">
          <div class="flex"></div>
          <button [disabled]='!inputBulletinNumber' (click)='reactivateOrDeactivateBulletin()' class="bmw-bulletin-save-button flex-90-px">
            <i class="material-icons">save</i>Save
          </button>
        </div>
      </div>
      <!-- Legacy -->
  
      <div *ngIf='showAllBulletinOptions'>
      
      <!-- Voluntary Recall Campaign -->
      <!-- Recall Campaign -->
      <!-- Service Action -->
      <!-- Start - End Date -->
      <!-- Model(s) -->
      <div class="bmw-bulletin-info">
        <div class="flex-container pointer" (click)='expandAccordian[5] = !expandAccordian[5]' data-toggle="collapse" href="#model">
          <div class="bmw-bulletin-info-title flex-95">Model(s)</div>
          <div class="accordian flex">
            <i class="material-icons">{{expandAccordian[5] ? 'remove' : 'add'}}</i>
          </div>
        </div>
        <div id="model" class="flex-container collapse" >
          <div class="bmw-bulletin-model-filters">
            <div class="bmw-model-filter">
              <div class="bmw-model-filter-label">Series:</div>
              <div class="bmw-model-chips">
                <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
                  {{series}}
                  <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i>
                </div>
              </div>
            </div>
          </div>
          <div class="bmw-bulletin-model-dropdowns">
            <div class="flex-container">
              <div class="flex-12">Series</div>
              <div class="flex-4"></div>
              <div class="flex-23">Vehicle Codes</div>
            </div>
            <div class="flex-container">
              <div class="flex-12">
                <input list="series" id="seriesList" [(ngModel)]='inputSeries' (change)='addToSelection("series", inputSeries)' name="seriesList"
                />
                <datalist id="series">
                  <option *ngFor="let series of seriesList" [ngValue]="series">{{series?.seriesName}}</option>
                </datalist>
              </div>
              <div class="flex-4"></div>
              <div class="flex-23">
                <textarea ref-textarea [(ngModel)]="vehicleCodesFilterList" style="width: 400px" rows="5"></textarea>

              </div>
            </div>
          </div>
          <div class="flex-container">
            <div class="flex"></div>
            <div class="bmw-bulletin-section-buttons flex">
              <div class="bmw-bulletin-cancel-button flex-90-px" (click)='clearModelData()'>
                <i class="material-icons">do_not_disturb</i>Clear
              </div>
              <button [disabled]='!inputBulletinNumber' (click)='validateModelCodes(vehicleCodesFilterList)' class="bmw-bulletin-save-button flex-90-px"
              data-toggle="modal"
              data-target="#agCodeValidation">
                <i class="material-icons">save</i>Save
              </button>
            </div>
          </div>
        </div>
      </div>

       <!-- Defect Code -->
       <div *ngIf="bulletinType === 1" class="bmw-bulletin-info">
        <div class="pointer flex-container" (click)='expandAccordian[6] = !expandAccordian[6]' data-toggle="collapse" href="#defect">
          <div class="bmw-bulletin-info-title flex-95">Defect/Fault Code(s)</div>
          <div class="accordian flex">
            <i class="material-icons">{{expandAccordian[6] ? 'remove' : 'add'}}</i>
          </div>
        </div>
        <div id="defect" class="flex-container collapse">
         
          <div class="bmw-bulletin-model-filters">
            <div class="bmw-model-filter">
              <div class="bmw-model-filter-label">Codes:</div>
              <div class="bmw-model-chips">
                <div class="bmw-bulletin-series-chips" *ngFor='let defects of defectFilterList'>
                  {{defects}}
                  <i class="material-icons" (click)='removeFromSelection("defects", defects)'>close</i>
                </div>
              </div>
            </div>
            
          </div>
          <div class="flex-container"><small style="color:red">{{defectCodeErrorMessage}}</small></div>
          <div class="flex-container"><small style="color:red">{{faultCodeErrorMessage}}</small></div>
          <div class="bmw-bulletin-model-dropdowns">
          <!-- <div> -->
            <div class="flex-container">
              <div class="flex-22">Defect Code</div>
             
              <div class="flex-4"></div>
              <div class="flex-15">Fault Codes</div>
             
            </div>
            <div class="flex-container">
              <div class="flex-22">
                <input list="defects" id="defectCodesInput" oninput="this.value = this.value.toUpperCase()" [(ngModel)]='inputDefect' maxlength="15" (change)='addToSelection("defects", inputDefect)' name="defectList"/>
                <datalist id="defects">
                  <option *ngFor="let defect of defectCodesList" [ngValue]="defect">{{defect?.defectCode}}</option>
                </datalist>
              </div>
              <div class="flex-4"></div>
              <div class="flex-13">
                <textarea ref-textarea oninput="this.value = this.value.toUpperCase()" [(ngModel)]="faultCodesFilterList" style="width: 400px" rows="5"></textarea>
               </div>
             
            </div>
          </div>
          <div class="flex-container">
            <div class="flex"></div>
            <div class="bmw-bulletin-section-buttons flex" >
              <div class="bmw-bulletin-cancel-button flex-90-px" (click)='initializeDefectSectionData()'>
                <i class="material-icons">do_not_disturb</i>Clear
              </div>
              <button [disabled]='!inputBulletinNumber' (click)='validateDefectCodes(faultCodesFilterList)' class="bmw-bulletin-save-button flex-90-px"
              data-toggle="modal"
              data-target="#faultCodeValidation">              
                <i class="material-icons">save</i>Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Situation -->

      <!-- Legacy New-->

      <div class="bmw-bulletin-info">
          <div class="pointer flex-container" (click)='expandAccordian[13] = !expandAccordian[13]' data-toggle="collapse" href="#legacy">
            <div class="bmw-bulletin-info-title flex-95">Content</div>
            <div class="accordian flex">
              <i class="material-icons">{{expandAccordian[13] ? 'remove' : 'add'}}</i>
            </div>
          </div>
          <div class="collapse flex-container" id="legacy" >
            <div class="bmw-bulletin-voulantary-emissions-info">
              <div [froalaEditor]='options' [(froalaModel)]="legacyInfo"></div>
            </div>
            <div class="flex-container">
              <div class="flex"></div>
              <div class="bmw-bulletin-section-buttons flex">
                <div class="bmw-bulletin-cancel-button flex-90-px" (click)='legacyInfo="";'>
                  <i class="material-icons">do_not_disturb</i>Clear
                </div>
                <button [disabled]='!inputBulletinNumber' (click)='addRichDetailToBulletin("Legacy", legacyInfo)' class="bmw-bulletin-save-button flex-90-px">
                  <i class="material-icons">save</i>Save
                </button>
              </div>
            </div>
          </div>
        </div>
      <!-- Affected Vehicles -->
      <!-- Cause -->
      <!-- Correction -->
      <!-- Procedure -->
      <!-- Parts Information -->
      <!-- Warranty Information -->
      <!-- Supporting Materials -->
      <div class="bmw-bulletin-info">
        <div class="flex-container" class="pointer flex-container" (click)='expandAccordian[12] = !expandAccordian[12]' data-toggle="collapse" href="#supportingMaterials">
          <div class="bmw-bulletin-info-title flex-95">Supporting Materials</div>
          <div class="accordian flex">
            <i class="material-icons">{{expandAccordian[12] ? 'remove' : 'add'}}</i>
          </div>
        </div>
        <div id="supportingMaterials" class="flex-container collapse">
          <div class="bmw-bulletin-voulantary-emissions-info">
            <div class="flex-container">
              <div class="upload-btn-wrapper flex-150-px">
                <button class="btn">Choose File</button>
                <input type="file" multiple name="myfile" (change)='fileUpload($event)' />
              </div>
              <div class="bmw-bulletin-nofile-label flex">{{supportingMaterialFileName}}</div>
              <div *ngFor="let s of supportingMaterialMultipleFileName">{{ s }}</div>
            </div>
          </div>
          <div class="flex-container" >
              <div class="bmw-model-chips">
                <div class="bmw-bulletin-series-chips" *ngFor='let supportFile of supportingMaterialFileDisplay'>
                  {{ supportFile }}
                  <i class="material-icons" (click)='removeFromSelection("supportFile", supportFile)'>close</i>
                </div>
              </div>
            </div>
          <small style="color:red">{{supportingMaterialserrorMessage}}</small>
          <div class="flex-container">
            <div class="flex"></div>
            <div class="bmw-bulletin-section-buttons flex">
              <div class="bmw-bulletin-cancel-button flex-90-px" style="padding-right : 10px" (click)='supportingMaterialFileName="No File Selected"'>
                <i class="material-icons">do_not_disturb</i>Clear
              </div>
              <button [disabled]='!inputBulletinNumber' (click)='addSupportingMaterials("Supporting Materials")'
                class="bmw-bulletin-save-button flex-90-px">
                <i class="material-icons">save</i>Save
              </button>
              <div *ngIf='userInput?.action === "edit"' style="padding-left : 15px">
                <button (click)='deleteSupportingDocuments()' class="bmw-bulletin-cancel-button flex-90-px">
                  <i class="material-icons">delete</i>Delete All
                </button>
            </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Start Video section-->
      <div class="bmw-bulletin-info">
        <div class="pointer flex-container" (click)='expandAccordian[16] = !expandAccordian[16]' data-toggle="collapse" href="#videos">
          <div class="bmw-bulletin-info-title flex-95">Videos</div>
          <div class="accordian flex">
            <i class="material-icons">{{expandAccordian[16] ? 'remove' : 'add'}}</i>
          </div>
        </div>
        <div id="videos" class="flex-container collapse">

         <div class="bmw-bulletin-add-video-label">Add Existing Video</div>
          <div class="flex-container">
            <div class="flex-30">
              <label>Video Number</label>
              <input list="videoNumbers" id="videoNumbersInput" [(ngModel)]='supportingMaterialsVideo' (change)='addToSelection("video", supportingMaterialsVideo)'
                name="seriesList" />
              <datalist id="videoNumbers">
                <option *ngFor="let videoNumber of videoNumbersList" [ngValue]="videoNumber">{{videoNumber}}</option>
              </datalist>
            </div>
          </div>
          <div class="flex-container row">
            <div class="bmw-model-chips">
              <div class="bmw-bulletin-series-chips" *ngFor='let video of supportingMaterialVideoDisplayNumbers'>
                {{video}}
                <i class="material-icons" (click)='removeFromSelection("video", video)'>close</i>
              </div>
            </div>
          </div>
          <small style="color:red">{{supportingVideoserrorMessage}}</small>
          <div class="flex-container">
            <div class="flex"></div>
            <div class="bmw-bulletin-section-buttons flex">
              <div class="bmw-bulletin-cancel-button flex-90-px" (click)='supportingMaterialsVideo="";this.supportingMaterialVideoDisplayNumbers=[]'>
                <i class="material-icons">do_not_disturb</i>Clear
              </div>
              <button [disabled]='!inputBulletinNumber' (click)='addSupportingVideos()'
                class="bmw-bulletin-save-button flex-90-px">
                <i class="material-icons">save</i>Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--End video section-->
      </div>
      <!-- End of *ngIf -->
      <!-- Custom content start -->
      <!-- Custom content end -->
    </div>

    <div *ngIf='showAllBulletinOptions == true'>

    <div class="bmw-bulletin-right-panel flex-15">
        <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
        (click)='downloadPDF()' class="bmw-button-primary send">Download PDF</div>
      <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' 
      *ngIf='userRoles["isMasterAdmin"]==="true"'
        (click)='approveBulletin()' class="bmw-button-primary send">Publish</div>
    </div>
  </div>
  <!-- End of *ngIf -->
  </div>
  <!-- Modal dialog to edit date/Group number values -->
  <div class="modal" id="bulletinModal" role="dialog" #addBulletinModal>
    <div class="bmw-cms-add-new-bulletin modal-dialog">
      <div class="modal-content bmw-csm">
        <div class="modal-body">
          <div class="flex-container" class="pull-right">
            <i class="material-icons pointer" data-dismiss="modal">close</i>
          </div>
          <!-- <div class="cms-modal-select-make-checkbox">
            <label class="container" *ngFor='let make of makeList'>{{make?.makeName}}
              <input type="radio" name="radio" [value]="make" [(ngModel)]='inputMake'>
              <span class="checkmark"></span>
            </label>
          </div> -->
          <div class="bmw-cms-add-bulletin-modal-content">
            <!-- For SIB and TRI -->
            <div>
              <label>Main Group</label>
              <div class="bmw-cms-new-bulletin-select">
                <select class="form-control" id="group" [(ngModel)]='inputGroup'>
                  <option [ngValue]="undefined" disabled selected> Select Main Group </option>
                  <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
                </select>
              </div>
              <div class="flex-container">
                <div class="flex-50">
                  <label>Date</label>
                  <div>
                    <!-- TODO: may be removed -->
                    <!-- <my-date-picker [selDate]='selReleaseDate' name="mydate" [options]="myDatePickerOptions2" [(ngModel)]="releaseDate" required></my-date-picker> -->
                    <input type="date" name="mydate" class="form-control" [(ngModel)]="releaseDate" required />
                  </div>
                </div>
              </div>
              <div class="flex-container row">
                <div class="flex-50" style="margin-top:25px">
                  <label class="container is-takata-recall">Is Takata Recall?
                    <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="flex-50">
                  <label>Takata Recall Code</label>
                  <div>
                    <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428" [(ngModel)]="tkrCode" required>
                  </div>
                </div>
              </div>
              <div class="bmw-cms-modal-button new-bulletin">
                <button class="bmw-button-secondary" data-dismiss="modal" (click)='updateFields()'>Enter Manually</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="agCodeValidation" role="dialog" #agCodeValidationModal style="border:5px">
      <div class="modal-dialog">
        <div class="modal-content bmw-login-lg-modal">
          <div class="modal-body">
            <div class="flex-container" class="pull-right">
              <i class="material-icons pointer" data-dismiss="modal">close</i>
            </div>
            <div class="bmw-login-modal-title"><b>Metadata Validation</b></div>
            <hr/>
            <div *ngIf='agValidation;else elseBlock'>
                <small style="color:black">Are you sure want to save entered codes?</small>
            </div>
            <ng-template #elseBlock>
              <small style="color:black">The following AG codes are not valid {{invalidCodes}}. Please hit cancel and correct the codes or hit save to continue and update the valid codes.</small>
            </ng-template>
            <br/>
            <small style="color:red"></small>
            <hr/>
            <div>
              <button type="button" class="bmw-login-modal-button" style="margin-left: 30%" (click)='addModelDataToBulletin()' data-dismiss="modal">Save</button>
              <button type="button" class="bmw-login-modal-button" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  <div class="modal" *ngIf="(faultCodeErrorMessage === '' && defectCodeErrorMessage === '')"  id="faultCodeValidation" role="dialog" #faultCodeValidationModal style="border:5px">
        <div class="modal-dialog">
          <div class="modal-content bmw-login-lg-modal">
            <div class="modal-body">
              <div class="flex-container" class="pull-right">
                <i class="material-icons pointer" data-dismiss="modal">close</i>
              </div>
              <div class="bmw-login-modal-title"><b>Metadata Validation</b></div>
              <hr/>
              <div *ngIf='faultValidation'>
                  <small style="color:black">Are you sure want to save entered codes?</small>
              </div>
              <ng-template #elseFaultBlock>
                <small style="color:black">The following Fault codes are not valid {{invalidFaults}}. Please hit cancel and correct the codes or hit save to continue and update the valid codes.</small>
              </ng-template>
              <br/>
              <small style="color:red"></small>
              <hr/>
              <div>
                <button type="button" class="bmw-login-modal-button" style="margin-left: 30%" (click)='addDefectDataToBulletin()' data-dismiss="modal">Save</button>
                <button type="button" class="bmw-login-modal-button" data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>